import React, { useEffect } from 'react';
import { Col, Row } from 'antd';
import ScopeThreeCategoryCard from 'shared/components/ScopeThreeCategoryCard';
import { ReactComponent as CategoryTen } from 'assets/icons/factory_cat_10.svg';
import { ReactComponent as CategoryEleven } from 'assets/icons/inventory_cat_11.svg';
import { ReactComponent as CategoryTwelve } from 'assets/icons/dustbin_cat_12.svg';
import { ReactComponent as CategoryThirteen } from 'assets/icons/cat_13.svg';
import { ReactComponent as CategoryFourteen } from 'assets/icons/franchise_cat_14.svg';
import { ReactComponent as CategoryFifteen } from 'assets/icons/money_bag_cat_15.svg';
import styles from './scopeDownstreamList.module.scss';
import useRedirect from 'shared/utils/useRedirect';
import { useParams } from 'react-router-dom';
import ScopeThreeService from 'services/ScopeThreeService/scopeThree.service';
import useFilters from 'shared/hooks/useFilters';
import { queryParamsList } from '..';
import LoaderAnimation from 'shared/components/LoaderAnimation';

const ScopeThreeDownStreamList = () => {
  const { getParams } = useFilters();
  const { activeTab } = getParams(queryParamsList);
  const { id: locationId } = useParams();
  const { loading, fetchCategories, scopeThreeCategories } =
    ScopeThreeService();
  useEffect(() => {
    fetchCategories(Number(locationId), activeTab);
  }, []);
  const categoriesList = [
    {
      label: 'category_10',
      icon: <CategoryTen />,
      name: 'Category 10',
      title: 'Processing Of Sold Products',
      subHeading:
        'Emissions from further processing of intermediate products sold by the company.',
    },
    {
      label: 'category_11',
      icon: <CategoryEleven />,
      name: 'Category 11',
      title: 'Use Of Sold Products',
      subHeading:
        'Emissions from the use of products sold by the company over their lifetime.',
    },
    {
      label: 'category_12',
      icon: <CategoryTwelve />,
      name: 'Category 12',
      title: 'End-Of-Life Treatment Of Sold Products',
      subHeading:
        'Emissions from the disposal of products sold by the company at the end of their lifecycle.',
    },
    {
      label: 'category_13',
      icon: <CategoryThirteen />,
      name: 'Category 13',
      title: 'Downstream Leased Assets',
      subHeading:
        'Emissions from the operation of leased assets by other entities, not included in Scope 1 and 2.',
    },
    {
      label: 'category_14',
      icon: <CategoryFourteen />,
      name: 'Category 14',
      title: 'Franchises',
      subHeading:
        'Emissions from the operations of franchises not included in Scope 1 and 2.',
    },
    {
      label: 'category_15',
      icon: <CategoryFifteen />,
      name: 'Category 15',
      title: 'Investments',
      subHeading:
        'Emissions from investments and financial activities managed by the company.',
    },
  ];
  const updateCategoriesStatus = categoriesList.map(category => {
    const matchedStatus = scopeThreeCategories.find(
      status => status.label === category.label
    );
    return {
      ...category,
      status: matchedStatus ? matchedStatus.status : undefined,
    };
  });
  return (
    <div className={styles.upstreamContainer}>
      {loading ? (
        <div className={styles.loaderAnimation}>
          <LoaderAnimation />
        </div>
      ) : (
        <Row gutter={[24, 24]}>
          {updateCategoriesStatus.map(categories => {
            const { icon, name, title, subHeading } = categories;
            return (
              <Col span={8} key={name}>
                <ScopeThreeCategoryCard
                  icon={icon}
                  name={name}
                  title={title}
                  subHeading={subHeading}
                />
              </Col>
            );
          })}
        </Row>
      )}
    </div>
  );
};

export default ScopeThreeDownStreamList;